import { store } from "./store";

export default {
    launch: {},

    generateKey(action, arg) {
        let key = action;
        if (arg) {
            if (arg instanceof Object) {
                Object.values(arg).forEach(value => {
                    if (typeof value === "string" || typeof value === "number") {
                        key += "_" + value;
                    }
                });
            } else if (arg instanceof Array) {
                arg.forEach(value => {
                    if (typeof value === "string" || typeof value === "number") {
                        key += "_" + value;
                    }
                });
            } else if (typeof value === "string" || typeof value === "number") {
                key += "_" + arg;
            }
        }
        return key;
    },

    getters(getter) {
        return store.getters[getter];
    },

    actions(action, arg = null) {
        let key = this.generateKey(action, arg);
        // console.log(key, this.launch[key])
        let actionLauch = this.launch[key];
        if (!actionLauch) {
            this.launch[key] = new Promise((resolve, reject) => {
                if (arg === null) {
                    store.dispatch(action).then(res => {
                        resolve(res);
                    });
                } else {
                    store.dispatch(action, arg).then(res => {
                        resolve(res);
                    });
                }
            });
        }
        return this.launch[action];
    }
};



// WEBPACK FOOTER //
// ./src/store/storeUtils.js